export const getLabelResellerPrice = (tags?: string[]) => {
  if (tags?.some((item) => item === 'Preço do Revendedor')) {
    return 'preco-da-revendedora'
  }

  return ''
}
